import { FINAL_SWITCH_ACTIVE_TAB } from '../actions/final';
import {
    WRAP
} from '../../FinalViews';

const updateFinal = (state = {}, action) => {
    const { type = null, datasource } = action;
    const { activeTab } = state;

    if (type === 'dataEngine_update_response' && datasource === 'gumbo') {
        const numberOfPlays = action?.data?.liveData?.plays?.allPlays?.length || 0;
        return {
            ...state,
            numberOfPlays
        };
    } else if (type === FINAL_SWITCH_ACTIVE_TAB) {
        return {
            ...state,
            activeTab: action.activeTab
        };
    }

    return {
        activeTab: activeTab || WRAP,
        ...state
    };
};

export default updateFinal;
